export interface IpsMelissaValidation {
  isValid: boolean;
  resultCodes: string;
}
